import { render } from "./FPCChecklist.vue?vue&type=template&id=55c05f34&scoped=true"
import script from "./FPCChecklist.vue?vue&type=script&lang=js"
export * from "./FPCChecklist.vue?vue&type=script&lang=js"

import "./FPCChecklist.vue?vue&type=style&index=0&id=55c05f34&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c05f34"]])

export default __exports__